<template>
  <div style="margin: 0 auto; max-width: 960px;">
    <HeaderBar
      save-mode="create"
      view="save"
      :showText="false"
      :showBar="hasChanges"
      @discard="discardModalOpen = true"
      @save="createPartner"
    />
    <BackButton
      link="/integration-partners/add"
      text="Back to Integration Partners"
    />
    <DashboardHeader
      heading="Create Integration Partner Profile"
      paragraph="Enter details to add this partner profile to your directory"
    />
    <div :key="formKey">
      <div class="mb-4">
        <Input
          v-model="name"
          id="name"
          name="name"
          placeholder="Acme, Inc"
          label="Company name"
          required
        />
      </div>
      <div class="mb-4">
        <FileUploader
          :existingImg="newIntegrationPartnerForm.image"
          label="Company logo"
          field="file"
          :required="true"
          accept=".png, .jpg, .jpeg, .gif"
          buttonText="Remove file"
          uploadDescription="<p class='fs-sm' style='color: #727a88;'><span style='font-weight: 600;'>File type:</span> JPG, PNG | <span style='font-weight: 600'>Min-width:</span> 400px | <span style='font-weight: 600'>Background:</span> Transparent</p>"
          zoneText="Upload or drop here your logo"
          @update-image="updateImage"
        />
      </div>
      <div class="mb-4">
        <Input
          v-model="aboutUs"
          type="texteditor"
          :limit="1000"
          id="aboutUs"
          name="aboutUs"
          label="About"
          required
        />
      </div>
    </div>
    <transition name="fade">
      <Modal
        v-if="discardModalOpen"
        :dark="true"
        :old="false"
        :newButtons="true"
        :modalShowing="true"
        title="Discard changes?"
        description="Are you sure you want to discard all the changes?"
        @close-modal="discardModalOpen = false"
        primaryText="Discard changes"
        secondaryText="Cancel"
        @primary-click="discardChanges"
        @secondary-click="discardModalOpen = false"
      />
    </transition>
  </div>
</template>

<script>
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import BackButton from '@/components/BackButton';
import FileUploader from '@/components/DesignSystem/FileUploader.vue';
import HeaderBar from '@/components/DesignSystem/HeaderBar.vue';
import Input from '@/components/DesignSystem/Input';
import Modal from '@/components/DesignSystem/Modal';

import { createNamespacedHelpers } from 'vuex';
const {
  mapActions,
  mapState,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers('integrationPartners/addIntegrationPartner');

export default {
  name: 'integrationParntersCreate',
  components: {
    DashboardHeader,
    BackButton,
    HeaderBar,
    FileUploader,
    Input,
    Modal,
  },
  data() {
    return {
      formKey: 0,
      discardModalOpen: false,
    };
  },
  methods: {
    ...mapActions(['createPartner', 'updateImage']),
    ...mapMutations([
      'clearNewIntegrationPartnerForm',
      'updateNewIntegrationPartnerForm',
    ]),
    discardChanges() {
      this.clearNewIntegrationPartnerForm();
      this.formKey++;
      this.discardModalOpen = false;
    },
  },
  computed: {
    ...mapState(['newIntegrationPartnerForm']),
    ...mapGetters(['hasChanges']),
    name: {
      get() {
        return this.newIntegrationPartnerForm.name;
      },
      set(value) {
        this.updateNewIntegrationPartnerForm({
          key: 'name',
          value,
        });
      },
    },
    aboutUs: {
      get() {
        return this.newIntegrationPartnerForm.aboutUs;
      },
      set(value) {
        this.updateNewIntegrationPartnerForm({
          key: 'aboutUs',
          value,
        });
      },
    },
  },
};
</script>
